import fetch from "auth/FetchInterceptor";

const ProductService = {};

ProductService.getProducts = function (page = 1, headers = {}, params = {}) {
  let url = `/products/?page=${page}`;
  
  if (params.search) {
    url += `&search=${encodeURIComponent(params.search)}`;
  }
  
  if (params.category_id) {
    url += `&category_id=${params.category_id}`;
  }

  if (params.stock_status) {
    url += `&stock_status=${params.stock_status}`;
  }
  
  return fetch({
    url: url,
    method: "get",
    headers: {
      ...headers,
    },
  });
};

ProductService.getProduct = function (productId, language_id) {
  return fetch({
    url: `/products/${productId}/`,
    method: "get",
    headers: {
      "Language-Id": language_id,
    },
  });
};

ProductService.createProduct = function (product) {
  return fetch({
    url: "/products/",
    method: "post",
    data: product,
  });
};

ProductService.updateProduct = function (data, productId) {
  return fetch({
    url: `/products/${productId}/`,
    method: "put",
    data: data,
  });
};

ProductService.deleteProduct = function (productId) {
  return fetch({
    url: `/products/${productId}/`,
    method: "delete",
  });
};

ProductService.setProductStatus = function (productId, status) {
  return fetch({
    url: `/products/${productId}/update-status/`,
    method: "patch",
    data: { status },
  });
};

ProductService.getOptionsValues = function (languageId) {
  return fetch({
    url: "/option-values/",
    method: "get",
    headers: {
      "Language-Id": languageId,
    },
  });
};

// Download the Excel bulk-upload template (Products + Instructions + Categories).
ProductService.downloadBulkTemplate = function () {
  return fetch({
    url: "/products/bulk/template/",
    method: "get",
    responseType: "blob",
  });
};

// Export the store's products to an Excel file. Optional filters (search,
// category_id, stock_status, channel) limit the export to the current view.
ProductService.exportProducts = function (params = {}) {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      query.append(key, value);
    }
  });
  const qs = query.toString();
  return fetch({
    url: `/products/bulk/export/${qs ? `?${qs}` : ""}`,
    method: "get",
    responseType: "blob",
  });
};

// Start a background bulk upload. Returns immediately with a job id; the
// products are created on the server in the background.
ProductService.startBulkUpload = function (file, onUploadProgress) {
  const formData = new FormData();
  formData.append("file", file);
  return fetch({
    url: "/products/bulk/upload-async/",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 120000,
    onUploadProgress,
  });
};

// Poll a background bulk upload job for progress and the per-row log.
ProductService.getBulkJobStatus = function (jobId) {
  return fetch({
    url: `/products/bulk/jobs/${jobId}/`,
    method: "get",
  });
};

// Download the Excel template for bulk product UPDATE (qty/price/ean/categories).
ProductService.downloadBulkUpdateTemplate = function () {
  return fetch({
    url: "/products/bulk/update-template/",
    method: "get",
    responseType: "blob",
  });
};

// Start a background bulk product UPDATE by SKU. Returns a job id.
ProductService.startBulkUpdate = function (file, onUploadProgress) {
  const formData = new FormData();
  formData.append("file", file);
  return fetch({
    url: "/products/bulk/update-async/",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
    },
    timeout: 120000,
    onUploadProgress,
  });
};

export default ProductService;
